import { createFileRoute, redirect } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { getVisibleManagementTabs } from '~/components/Header/navigation/subRoutes/getVisibleManagementTabs';
import { ROLES } from '~/constants';
import { authoriseUser } from '~/features/auth/utils/authoriseUser';
import { useUserStore } from '~/store/userStore';

export const Route = createFileRoute('/_app/management/')({
    beforeLoad: ({ location }) => {
        authoriseUser(Object.values(ROLES), location);
        const tabs = getVisibleManagementTabs(useUserStore.getState().user?.role);
        if (tabs.length === 1) {
            throw redirect({ replace: true, search: tabs[0].search, to: tabs[0].to });
        }
    },
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    component: () => <ManagementMain />,
});

const ManagementMain = () => {
    const { t } = useTranslation();
    return (
        <section className="page">
            <section className="content pt-4">
                <div style={{ alignItems: 'center', display: 'flex', justifyContent: 'center' }}>
                    <span>{t('PAGES.CRM_MANAGEMENT')}</span>
                </div>
            </section>
        </section>
    );
};
